import React, { useEffect, useRef, useState } from "react"
import { FaSearch } from "react-icons/fa"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Input, Spinner } from "components"
import { getOrderByCode } from "services"
import classes from "./RmSearch.module.scss"

const RmSearch = props => {
  const { setOrdersForDispatch } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)
  const [search, setSearch] = useState("")

  const unmount = useRef(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    setSending(true)

    setSearch("")

    try {
      const response = await getOrderByCode(search)

      if (unmount.current) return

      if (!response) {
        setSending(false)

        toast.error(t(`سفارش_search_یافت_نشد`, { search }))

        return
      }

      if (response.orderStatus !== "delivered") {
        setSending(false)

        toast.error(t("سفارش_search_هنوز_به_انبار_تحویل_داده_نشده", { search }))

        return
      }

      if (response.isDispatched) {
        setSending(false)

        toast.error(t("سفارش_search_از_انبار_خارج_شده", { search }))

        return
      }

      setOrdersForDispatch(prev => {
        const exists =
          prev.some(eo => eo._id === response._id)

        if (exists) return prev

        return [...prev, response]
      })
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_search_یافت_نشد", { search }))
    }

    setSending(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <form
      onSubmit={handleSubmit}
      className={classes["container"]}
    >
      {sending ? <Spinner /> : <FaSearch color="white" />}
      <Input
        withoutSpace
        numberType="int"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={t("سفارشات_را_با_کد_جست_و_جو_کنید")}
        className={clsx(
          classes["input"],
          isLtr && classes["input-ltr"]
        )}
      />
    </form>
  )
}

export default RmSearch